import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../store/useAuth.js';
import { Loader } from './States.jsx';

/**
 * Nothing inside renders until we know who is signed in. App runs the /auth/me
 * query; this only waits for `booted`, so a signed-out visitor is never bounced
 * to /login before the answer arrives.
 */
export default function RequireAuth() {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="auth-boot">
        <Loader label="Checking your session…" />
      </div>
    );
  }

  // Remember where they were headed, so login can send them back there.
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;

  return <Outlet />;
}
